import {Component, ChangeDetectionStrategy} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-payment-block-reason-dialog',
    templateUrl: './payment-block-reason-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentBlockReasonDialogComponent {

    reason: string = '';

    constructor(
        public readonly dialogRef: MatDialogRef<PaymentBlockReasonDialogComponent>
    ) {}

    onConfirm(): void {
        this.dialogRef.close(this.reason.trim());
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }
}
